<template>
	<t-icon-button
		v-if="shrink"
		:icon="icon"
		v-bind="$attrs"
		v-on="$listeners"
	/>

	<t-button
		v-else
		:iconBefore="iconBefore"
		:iconAfter="iconAfter"
		v-bind="$attrs"
		v-on="$listeners"
	/>
</template>

<script>
export default {
	name: 'TShrinkableButton',
	props: {
		/**
		 * Wether to shrink button into t-icon-button or not.
		 */
		shrink: Boolean,
		/**
		 * Sets an icon before the text. Can be any icon from TTimpexIcon.
		 */
		iconBefore: String,
		/**
		 * Sets an icon after the text. Can be any icon from TTimpexIcon.
		 */
		iconAfter: String,
	},
	computed: {
		icon() {
			if (this.iconBefore) return this.iconBefore;
			if (this.iconAfter) return this.iconAfter;
			return 'more';
		},
		getStyle() {
			return {
				textAlign: (!this.iconBefore && !this.iconAfter ? 'center' : 'left'),
				width: this.width
			};
		},
		disableButton() {
			return this.disabled || this.busy;
		},
	}
};
</script>

<style lang="scss" scoped>
@import './scss/';

.button-inner {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex:1;
}

.before, .after {
	pointer-events: none;
	flex-shrink: 0;
}

.before {
	margin-left: -3px;
	margin-right: 8px;
}

.after {
	margin-left: 8px;
	margin-right: -3px;
}
</style>
